import { render } from "./PeriodicUpdate.vue?vue&type=template&id=255afcd5&scoped=true&ts=true"
import script from "./PeriodicUpdate.vue?vue&type=script&lang=ts"
export * from "./PeriodicUpdate.vue?vue&type=script&lang=ts"

import "./PeriodicUpdate.vue?vue&type=style&index=0&id=255afcd5&lang=scss&scoped=true"

import exportComponent from "/src/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255afcd5"]])

export default __exports__